import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {EmptyFilteredContentListProps} from './EmptyFilteredContentListProps.interface';

export function EmptyFilteredContentList({
  className,
  ...props
}: EmptyFilteredContentListProps) {
  return (
    <div
      className={twMerge('flex h-62pxr justify-center', className)}
      {...props}
    >
      <Text className="font-medium1 text-theme-solid-100">
        {t('library_tab_recent_search_no_episode')}
      </Text>
    </div>
  );
}
